import React from 'react';
import { getSeededRandom } from '../util/helpers';
import './Stroke.scss';

const Stroke = (props) => {
  const {
    seedStr = 'seed',
    hasViewBox,
  } = props;
  const numStrokes = 6;
  const strokeIndex = Math.floor(getSeededRandom(seedStr) * numStrokes);
  switch (strokeIndex) {
    case (0):
      return (
        <svg className="stroke" viewBox={hasViewBox ? '0 0 137 14' : undefined} xmlns="http://www.w3.org/2000/svg">
          <path d="M1.994 7.427c6.488-1.934 14.527-2.79 24.117-2.567 27.28.633 83.191 8.597 109.168 0" strokeWidth="8" fill="none" fillRule="evenodd" />
        </svg>
      );
    case (1):
      return (
        <svg className="stroke" viewBox={hasViewBox ? '0 0 137 14' : undefined} xmlns="http://www.w3.org/2000/svg">
          <path d="M1.279 7.613c3.386.978 9.675 1.52 18.868 1.627 12.345.143 33.373-5.398 52.045-4.894 20.882.564 45.94 7.067 59.087 4.894" strokeWidth="8" fill="none" fillRule="evenodd" />
        </svg>
      );
    case (2):
      return (
        <svg className="stroke" viewBox={hasViewBox ? '0 0 137 14' : undefined} xmlns="http://www.w3.org/2000/svg">
          <path d="M1.279 7.827C11.937 5.53 21.667 4.423 30.468 4.5c11.819.106 22.028 4.48 39.903 4.852 10.492.218 22.572-3.71 34.176-4.852 10.507-1.034 20.75.761 26.732 0" strokeWidth="8" fill="none" fillRule="evenodd" />
        </svg>
      );
    case (3):
      return (
        <svg className="stroke" viewBox={hasViewBox ? '0 0 137 14' : undefined} xmlns="http://www.w3.org/2000/svg">
          <path d="M3.279 5.08c1.545 1.27 6.995 1.95 16.348 2.041 11.325.11 16.907-1.285 35.44-1.485 12.692-.137 29.71 3.526 44.498 3.402 14.348-.12 26.547-4.014 33.714-5.01" strokeWidth="8" fill="none" fillRule="evenodd" />
        </svg>
      );
    case (4):
      return (
        <svg className="stroke" viewBox={hasViewBox ? '0 0 137 14' : undefined} xmlns="http://www.w3.org/2000/svg">
          <path d="M.279 5.06c25.212-.215 42.493-.215 51.844 0 26.601.613 52.826 8.322 78.156 0" strokeWidth="8" fill="none" fillRule="evenodd" />
        </svg>
      );
    default:
      return (
        <svg className="stroke" viewBox={hasViewBox ? '0 0 137 14' : undefined} xmlns="http://www.w3.org/2000/svg">
          <path d="M1.994 7.427c6.488-1.934 14.527-2.79 24.117-2.567 27.28.633 83.191 8.597 109.168 0" strokeWidth="8" fill="none" fillRule="evenodd" />
        </svg>
      );
  }
};

export default Stroke;
